import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, tokenStore, userStore } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(userStore.get());
    const [loading, setLoading] = useState(!!tokenStore.get());

    const refresh = useCallback(async () => {
        if (!tokenStore.get()) {
            setUser(null);
            setLoading(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            userStore.set(data);
        } catch {
            tokenStore.clear();
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        tokenStore.set(data.token);
        userStore.set(data.user);
        setUser(data.user);
        return data.user;
    };

    const signup = async (payload) => {
        const { data } = await api.post("/auth/signup", payload);
        tokenStore.set(data.token);
        userStore.set(data.user);
        setUser(data.user);
        return data.user;
    };

    const logout = () => {
        tokenStore.clear();
        setUser(null);
        window.location.href = "/login";
    };

    return (
        <AuthCtx.Provider value={{ user, loading, login, signup, logout, refresh }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
